namespace TabAurous.OMS {
    export interface OrderStatusRow {
        AttributeId?: number;
        AttributeTypeId?: number;
        AttributeCode?: string;
        AttributeName?: string;
    }

    export namespace OrderStatusRow {
        export const idProperty = 'AttributeId';
        export const nameProperty = 'AttributeCode';
        export const localTextPrefix = 'OMS.OrderStatus';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            AttributeId = "AttributeId",
            AttributeTypeId = "AttributeTypeId",
            AttributeCode = "AttributeCode",
            AttributeName = "AttributeName"
        }
    }
}
